export class LoginModel {
    LoginId!: string
    Password!: string
    adfsId!: string
    adfs!: string
    timestamp!: string
    FACode!: string
}


export class SystemValueModel {
    RowId!: number
    Value!: string
    Unit!: string
    LastModifyDatetime !: Date
}

export class EmailTemplateModel {
    RowId!: number
    EmailType!: string
    EmailTitle!: string
    EmailContent!: string
    LastModifyDatetime !: Date
}


export class NonHKCCUserModel {
 
    UserName!: string
    Email!: string
    Type!: string
    Status!: string
    Mobile!: string
    Institution!: string
    Programme!: string
    Password!: string
    ConfirmPassword!: string
}

export class UserModel {
    RowId!: number
    UserId!: string
    UserName!: string
    Email!: string
    Type!: string
    Status!: string
    Mobile!: string
    Year!: string
    Institution!: string
    Programme!: string
    Notes!: string
    ExtraQuota!: number
    ActionDateStr!: string
    LastModifyDatetime!: Date
}

export class StaffModel {
    RowId!: number
    UserId!: string
    UserName!: string
    Email!: string
    Title!: string
    Status!: string
    LastModifyDatetime!: Date
    permissionViewModel: any
}

export class PermissionModel {
    PermissionId!: string
    Description!: string
    HasPermission!: boolean
}

export class ExcelModel {
    File!: any
    ErrMsgs!: any
}

export class BookingSearchModel {
    CmsId!: any
    UserType!: any
    StartDate!: any
    EndDate!: any
}

export class BookingModel {
    RowId!: number
    UserId!: string
    CmsId!: string
    RefNo!: string
    Email!: string | null
    TimezoneDate: any
    TimeslotSessionRowId!: any
    Status !: string
    Groups: any
    LastModifyDatetime!: Date
}

export class GroupModel {
    UserRowId!: number
    UserName!: string
    UserId!: string
    Email!: string
}

export class TimeslotSearhModel {
    CmsId!: string
    TimezoneDate!: any
    TimeslotSessionRowId!: any
    IsFree!: boolean
}

export class ExperimentalSetCalendarModel {
    CmsId!: string
    Year!: any
    Month!: any
    Date!: any
}


export class ExperimentalSetModel {
    RowId!: number
    CmsId!: string
    Category!: string
    ExperimentalSetNameTc!: string
    ExperimentalSetNameSc!: string
    ExperimentalSetNameEn!: string
    ReservationPeriod!: number
    Duration!: number
    NeedApproval!: boolean
    Status!: string
    DisplayStatus!: string
    MaintenanceDay!: number
}